// Date labels for the Campaigns tab (EPD-12316, EPD-12318).

const DAY_MS = 86_400_000;

const parse = (iso: string | null | undefined): Date | null => {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
};

const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

/**
 * Oldest first by time, whatever the ISO format (`Z`, `.000Z`, `+00:00`).
 * Missing or unreadable dates sort last (EPD-12612).
 */
export function compareIsoAsc(
  a: string | null | undefined,
  b: string | null | undefined,
): number {
  const timeA = parse(a)?.getTime();
  const timeB = parse(b)?.getTime();
  if (timeA === undefined) return timeB === undefined ? 0 : 1;
  if (timeB === undefined) return -1;
  return timeA - timeB;
}

/** Whole calendar days between the date and today: "today", "1 day ago", "N days ago". */
export function daysAgoLabel(
  iso: string | null | undefined,
  now: Date = new Date(),
): string | null {
  const date = parse(iso);
  if (!date) return null;
  const days = Math.max(
    0,
    Math.round((startOfDay(now) - startOfDay(date)) / DAY_MS),
  );
  if (days === 0) return "today";
  if (days === 1) return "1 day ago";
  return `${days} days ago`;
}

/** "Oct 14, 2026". */
export function formatFullDate(iso: string | null | undefined): string | null {
  const date = parse(iso);
  return date
    ? date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;
}

/** "Aug 12". */
export function formatMonthDay(iso: string | null | undefined): string | null {
  const date = parse(iso);
  return date
    ? date.toLocaleDateString("en-US", { month: "short", day: "numeric" })
    : null;
}
